import { useCallback, useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { SearchableDropdownField } from 'ui-components/components/dropdown';

import { getCachedNormalizedBYOLProviders } from '../../../../../../../../hooks/use-normalized-BYOL-providers';
import { ProviderHelperService } from '../../../../../../../../services/provider-helper-service';
import Global from '../../../../../../../../store/global-selectors';
import { INT_PARAMETER } from '../../../../../constants/parameter-name-for-update';
import messages from './messages';

import style from '../style.module.less';

/**
 * @typedef {import('../../../../../types/automation-rule-types.d.ts').AutomationRuleActionInputValueProps} AutomationRuleActionInputValueProps
 */

/**
 * @param {object} props
 * @param {AutomationRuleActionInputValueProps} props.inputValueProps
 * @param {(updatedProps: AutomationRuleActionInputValueProps) => void} props.onChange
 * @param {ReactNode} props.label
 * @returns {JSX.Element}
 */
export const ShippingAccountSearchableDropdown = ({ inputValueProps, onChange, label }) => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const providers = useSelector(Global.selectReferenceDatagetProviders);

  const intl = useIntl();

  const options = useMemo(() => {
    const BYOLProviders = getCachedNormalizedBYOLProviders();

    return sellerLabelProviders.reduce(
      (acc, provider) =>
        BYOLProviders[provider.labelProviderId]
          ? acc
          : [
              ...acc,
              {
                value: provider.sellerLabelProviderId,
                label: ProviderHelperService.getSellerLabelProviderName(provider, providers, sellerLabelProviders),
              },
            ],
      [],
    );
  }, [sellerLabelProviders, providers]);

  const updateSelectedAccount = useCallback(
    (value) => {
      onChange({
        [INT_PARAMETER]: Number.parseInt(value, 10),
      });
    },
    [onChange],
  );

  const selectedAccountId = inputValueProps[INT_PARAMETER]?.toString();
  const placeholder = intl.formatMessage(messages.noOptionSelectedMessage);

  return (
    <div className={style['action-selector']}>
      <div>{label}</div>
      <SearchableDropdownField
        onItemSelected={updateSelectedAccount}
        options={options}
        placeholder={placeholder}
        selectedItemValue={selectedAccountId}
      />
    </div>
  );
};
